import type { Entry } from "./types";

type BadgeNavigator = Navigator & {
  setAppBadge?: (count?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
  standalone?: boolean;
};

export function dueTaskCount(entries: Entry[], now = new Date()): number {
  const current = now.getTime();
  return entries.filter((entry) =>
    entry.kind === "task" &&
    Boolean(entry.due_at) &&
    new Date(entry.due_at!).getTime() <= current &&
    !entry.completed_at &&
    entry.state !== "completed" &&
    !entry.archived_at &&
    !entry.trashed_at
  ).length;
}

export function supportsWebPush(): boolean {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export function needsIosHomeScreenInstall(): boolean {
  const ios = /iPhone|iPad|iPod/.test(navigator.userAgent);
  const standalone = window.matchMedia?.("(display-mode: standalone)").matches ||
    Boolean((navigator as BadgeNavigator).standalone);
  return ios && !standalone;
}

export async function syncAppBadge(entries: Entry[]): Promise<void> {
  if (!("Notification" in window) || Notification.permission !== "granted") return;
  const badgeNavigator = navigator as BadgeNavigator;
  const count = dueTaskCount(entries);
  try {
    if (count > 0 && badgeNavigator.setAppBadge) await badgeNavigator.setAppBadge(count);
    else if (badgeNavigator.clearAppBadge) await badgeNavigator.clearAppBadge();
  } catch {
    // Badges sind eine optionale Betriebssystemfunktion und dürfen den Arbeitsfluss nie blockieren.
  }
}

export async function clearAppBadge(): Promise<void> {
  try {
    await (navigator as BadgeNavigator).clearAppBadge?.();
  } catch {
    // Das Betriebssystem kann Badges trotz erteilter Benachrichtigungsfreigabe deaktivieren.
  }
}
